import { InjectionToken } from '@angular/core'
import { ClientConfig } from '@pai/commons'

export const CLIENT_CONFIG = new InjectionToken<ClientConfig>(ngDevMode ? 'CLIENT_CONFIG' : '')
